import store from '@/store'
import { FulfillmentType, AdjustmentType } from '@/cowboy/EnumTypes'
import { GET_CATALOG_BRANDS, GET_CATALOG_ITEMS } from '@/store/get-types'
import LineItem from '@/components/checkout/line_item'

class CartItem {
  constructor (
    utid,
    errorMessage,
    selectedAmount,
    fee,
    brand,
    currencyCode,
    image,
    name,
    editData,
    valueType,
    fulfillmentType,
    fulfillmentStatus,
    lineNumber
  ) {
    this.id = this.generateCartItemId()
    this.utid = utid
    this.errorMessage = errorMessage
    this.selectedAmount = selectedAmount
    this.fee = fee
    this.brand = brand
    this.currencyCode = currencyCode
    this.image = image
    this.name = name
    this.editData = editData || {
      brand: null,
      row: null,
      trianglePosition: null,
      animating: false,
      fulfillmentType: null
    }
    this.valueType = valueType
    this.fulfillmentStatus = fulfillmentStatus
    if (fulfillmentType) {
      this.fulfillmentType = FulfillmentType[fulfillmentType.toUpperCase()]
      this.editData.fulfillmentType = this.fulfillmentType
    }
    this.lineNumber = lineNumber
  }

  generateCartItemId () {
    return Math.random()
      .toString(36)
      .substr(2, 16)
  }

  toLineItem () {
    const lineItem = new LineItem()
    lineItem.utid = this.utid
    lineItem.amount = this.selectedAmount
    lineItem.fee = this.fee
    lineItem.fulfillmentType = this.fulfillmentType
    lineItem.rewardName = this.name

    return lineItem
  }
}

CartItem.Builder = class {
  utid (utid) {
    this._utid = utid
    this._item = null
    this._brand = null

    if (utid) {
      const items = store.getters[GET_CATALOG_ITEMS]
      const item = items.get(utid)

      if (item) {
        this._item = item
        const brand = store.getters[GET_CATALOG_BRANDS].get(item.brandID)

        if (brand) {
          this._brand = brand
        }
      }
    }

    return this
  }

  amount (amount) {
    this._amount = Number(amount).toFixed(2)
    this._fee = {}

    const { adjustment } = this._item || {}

    if (adjustment) {
      const { type, value } = adjustment
      this._fee = { type, value }
      if (value) {
        switch (type) {
          case AdjustmentType.FLAT:
            this._fee.cost = value
            break
          case AdjustmentType.PERCENTAGE:
            this._fee.cost = Number(
              Number(this._amount) * Number(value)
            ).toFixed(2)
            break
          default:
            console.error('Error calculating fee for cart item')
        }
      }
    }

    return this
  }

  build () {
    const { displayName, imageUrls } = this._brand || {}
    const { '278w-326ppi': imageUrl } = imageUrls || {}
    const { currencyCode, fulfillmentType, valueType } = this._item || {}

    return new CartItem(
      this._utid,
      null,
      this._amount,
      this._fee,
      this._brand,
      currencyCode,
      imageUrl,
      displayName,
      {},
      valueType,
      fulfillmentType
    )
  }
}

export default CartItem
